import styled from "styled-components";

type ConfirmDeleteModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: () => void;
  itemName: string;
};

const ConfirmDeleteModal = ({
  isOpen,
  toggle,
  onConfirm,
  itemName,
}: ConfirmDeleteModalProps) => {
  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalContainer>
        <ModalTitle>Excluir item</ModalTitle>
        <ModalMessage>
          Tem certeza que deseja excluir <strong>{itemName}</strong>?
        </ModalMessage>
        <ModalActions>
          <CancelButton onClick={toggle}>Cancelar</CancelButton>
          <DeleteButton onClick={onConfirm}>Deletar</DeleteButton>
        </ModalActions>
      </ModalContainer>
    </Overlay>
  );
};

export default ConfirmDeleteModal;


const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  background-color: #ffffff;
  padding: 32px;
  border-radius: 10px;
  min-width: 320px;
  max-width: 420px;
  border: 1px solid #e0eafc;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
`;

const ModalTitle = styled.h2`
  font-size: 22px;
  color: #2c3e50;
  margin-bottom: 16px;
`;

const ModalMessage = styled.p`
  font-size: 16px;
  color: #555;
  margin-bottom: 28px;
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;

const ButtonBase = styled.button`
  padding: 10px 20px;
  font-size: 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  min-width: 100px;
  transition: background 0.2s;
`;

const CancelButton = styled(ButtonBase)`
  background-color: #e0e0e0;
  color: #444;

  &:hover {
    background-color: #d0e7fb;
  }
`;

const DeleteButton = styled(ButtonBase)`
  background-color: #e74c3c;
  color: #fff;

  &:hover {
    background-color: #c0392b;
  }
`;
